export default function roundCoord(coord, tolerance) {
    return [
        Math.round(coord[0] / tolerance) * tolerance,
        Math.round(coord[1] / tolerance) * tolerance,
    ];
}
//# sourceMappingURL=round-coord.js.map